import { render, staticRenderFns } from "./CreateNewUserScreen.vue?vue&type=template&id=0e76b5f4&scoped=true&"
import script from "./CreateNewUserScreen.vue?vue&type=script&lang=ts&"
export * from "./CreateNewUserScreen.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNewUserScreen.vue?vue&type=style&index=0&id=0e76b5f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e76b5f4",
  null
  
)

export default component.exports